import { useQuery } from '@tanstack/react-query';
import { deerEndpoints } from 'Deer/constants/endpoints';
import { CohortType } from 'Deer/types/logeedInUsersAccesses';
import { sendRequest } from 'api/sendRequest';

import { useDeerViewId } from './useDeerViewId';

const viewFromQueryParam = 'viewFromQueryParam';

const fetchValidFeaturesForViewId = async ({ viewId }: { viewId: string }) => {
  try {
    const url = deerEndpoints.validFeaturesForViewId(viewId);
    // @ts-expect-error queryparams in required in sendRequest
    const res = await sendRequest({
      url,
      credentials: 'include',
      method: 'GET',
    });
    return res.entity;
  } catch (error) {
    console.error('Error fetching valid features for viewId', error);
    throw new Error('Error fetching valid features for viewId');
  }
};

export const useViewFromQueryParam = (viewIdParam = '') => {
  const { viewId: viewIdFromQueryParam } = useDeerViewId();
  const viewId = viewIdParam || viewIdFromQueryParam;
  const { data, isLoading, isError } = useQuery<CohortType>(
    [viewFromQueryParam, viewId],
    () =>
      fetchValidFeaturesForViewId({
        viewId,
      }),
    {
      enabled: !!viewId,
    }
  );

  return {
    data,
    isLoading,
    isError,
    viewId: viewIdFromQueryParam,
  };
};
